/**
 * Application bootstrap
 * ---------------------
 * This is the very first piece of our code that runs in the browser. Its job
 * is small but important:
 *   1. Create the root Vue application instance from the <App> component.
 *   2. Install plugins (here: the router).
 *   3. Mount everything into the <div id="app"> defined in index.html.
 *
 * Keeping this file tiny is intentional — wiring lives in dedicated modules
 * (router, composables) so the entry point stays readable.
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Global, un-scoped styles: CSS reset, design tokens (CSS variables), and a
// few utility classes shared across the whole app.
import './assets/styles/main.css'

const app = createApp(App)

// Vue Router powers client-side navigation between the landing page and the
// Google Meet / Zoom download pages without full page reloads.
app.use(router)

app.mount('#app')
